import React, { useState } from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import Modal from "../../../../../parts/modal-new";
import { getDateWithDayToDisplay } from "../../../../../utils/date-helpers";
import Select from "../../../../../parts/inputs/select";

export const MoveMealPlanModal = ({ locals }) => {
  const { query, mealPlan } = locals;
  const { date, athlete, mealPlan: mealPlanId, week = 1 } = query;
  const { weeks = [] } = mealPlan;
  const dateToUse = athlete ? date : `Week ${week} ${date}`;
  const allDates = weeks.flatMap(({ days }, weekIndex) =>
    days.map(({ date }, index) => ({
      text: date
        ? getDateWithDayToDisplay(date)
        : `Week ${weekIndex + 1} Day ${index + 1}`,
      value: date ?? `Week ${weekIndex + 1} Day ${index + 1}`,
    }))
  );

  const [endDateState, setEndDateState] = useState(dateToUse);

  /**
   * Close modal
   */
  const handleCancel = () => {
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: { "modal[type]": "", date: "" },
    });
  };

  /**
   * Select new date
   * @param {*} newVal
   */
  const handleSelectChange = (newVal) => {
    setEndDateState(newVal);
  };

  /**
   * Send information to the API
   */
  const handleSubmit = () => {
    const body = {
      initDate: dateToUse,
      endDate: endDateState,
      bodyAction: "handle-day",
      handle: "move",
      isTemplate: athlete ? false : true,
    };
    submit(
      `/actions/meal-planner/update-days-meal-plan?mealPlanId=${mealPlanId}&proxyAthlete=${athlete}`,
      {
        method: "POST",
        body,
      }
    );
  };

  return (
    <Modal
      className="move-meal-plan-modal"
      title={"Move Meal Plan"}
      toClear={["date"]}
    >
      <div className="body">
        <div className="info">
          <span className="label">Date</span>
          <span className="font-bold">
            {getDateWithDayToDisplay(dateToUse)}
          </span>
        </div>
        <div className={dateToUse === endDateState ? "select select-disabled" : "select"}>
          <span className="label">Move meal plan to</span>
          <Select
            withFocus
            name="endDate"
            value={endDateState}
            onChange={(newVal) => handleSelectChange(newVal)}
            options={allDates.map(({ text, value }) => {
              return { value, text };
            })}
          />
        </div>
        <div className="buttons">
          <button className="cancel" onClick={handleCancel}>
            Cancel
          </button>
          <button
            data-button-type="primary"
            onClick={handleSubmit}
            disabled={dateToUse === endDateState}
          >
            Move
          </button>
        </div>
      </div>
    </Modal>
  );
};

MoveMealPlanModal.propTypes = {
  locals: PropTypes.object,
};
